import React from "react";

interface StatsBarProps {
  wpm: number;
  accuracy: number;
  snippetIndex: number;
  totalSnippets: number;
  lessonTitle: string;
}

export default function StatsBar({
  wpm,
  accuracy,
  snippetIndex,
  totalSnippets,
  lessonTitle,
}: StatsBarProps) {
  return (
    <div className="flex items-center justify-between w-full px-4 py-2 bg-card border rounded-lg text-sm">
      <span className="text-muted-foreground font-medium">{lessonTitle}</span>
      <div className="flex items-center gap-6">
        <div>
          <span className="text-muted-foreground">WPM </span>
          <span className="font-bold text-foreground">{wpm}</span>
        </div>
        <div>
          <span className="text-muted-foreground">Accuracy </span>
          <span className="font-bold text-foreground">{accuracy}%</span>
        </div>
        <div>
          <span className="text-muted-foreground">Snippet </span>
          <span className="font-bold text-foreground">
            {snippetIndex + 1}/{totalSnippets}
          </span>
        </div>
      </div>
    </div>
  );
}
